import { ShieldCheck } from "lucide-react";

export const AbsolinDisclaimer = () => (
  <div className="bg-white border-t border-slate-200 py-4" data-testid="absolin-disclaimer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <div className="flex items-center justify-center gap-2">
        <ShieldCheck className="w-3.5 h-3.5 text-slate-400" />
        <p className="text-[11px] text-slate-500 leading-tight">
          This tool is proprietary to ABSOLIN SOFTWARE SOLUTIONS LLP. All rights reserved. &copy; 2014-{new Date().getFullYear()} | Unauthorized reproduction, distribution, or use of this tool is strictly prohibited.
        </p>
      </div>
    </div>
  </div>
);
